import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import {
  utils,
} from '@resy/ui-kitchen';
import AddOn from '../AddOn';
import OPENAI_WIDGET from '../../constants/srcTypes';

import './AddOnCollection.scss';

class AddOnCollection extends React.Component {
  static propTypes = {
    addOns: PropTypes.arrayOf(PropTypes.shape({
      available_inventory: PropTypes.shape({
        date: PropTypes.string,
        quantity: PropTypes.number,
      }),
      daily_limit: PropTypes.number,
      description: PropTypes.string.isRequired,
      image: PropTypes.string,
      item_id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      price: PropTypes.number,
      sort_order: PropTypes.number,
      quantity: PropTypes.number,
      total_quantity: PropTypes.number,
    })),
    categoryId: PropTypes.number,
    currencyCode: PropTypes.string,
    fulfilled: PropTypes.bool,
    max: PropTypes.number,
    maxSelected: PropTypes.bool,
    onChange: PropTypes.func,
    sourceId: PropTypes.string,
  }

  static defaultProps = {
    addOns: [],
    categoryId: undefined,
    currencyCode: undefined,
    fulfilled: undefined,
    max: undefined,
    maxSelected: undefined,
    onChange: () => {},
    sourceId: undefined,
  }

  getAddOn = (addOn) => {
    const {
      categoryId, currencyCode, fulfilled, maxSelected,
    } = this.props;

    const {
      available_inventory: inventory,
      daily_limit: dailyLimit,
      description,
      image,
      item_id: id,
      name,
      price,
      quantity,
      sort_order: sortOrder,
      total_quantity: totalQuantity,
    } = addOn;

    return {
      categoryId,
      dailyLimit,
      description,
      fulfilled: fulfilled || maxSelected,
      id,
      image,
      inventory,
      name,
      price: utils.getFormattedPrice(price, currencyCode),
      sortOrder,
      quantity,
      totalQuantity,
    };
  }

  renderAddOn = (addOn) => {
    const { onChange, max } = this.props;

    let overrideMax;
    // collection max takes precedent over individual addOn max when present
    if (typeof max === 'number') {
      // take into account the item's current quantity when determining the max selectable
      overrideMax = { max: addOn?.quantity + max };
    }

    return <AddOn {...addOn} {...overrideMax} key={addOn.id} onChange={onChange} />;
  }

  sortFormatAddOns = (addOns) => addOns
    .map(this.getAddOn)
    .sort((a, b) => (a.sortOrder > b.sortOrder ? 1 : -1))

  render() {
    const { addOns, sourceId } = this.props;
    const addOnsSortedFormatted = this.sortFormatAddOns(addOns);

    return (
      <div className={cx('AddOnCollection', { 'AddOnCollection--openAi': sourceId === OPENAI_WIDGET })}>
        {addOnsSortedFormatted && addOnsSortedFormatted.map(this.renderAddOn)}
      </div>
    );
  }
}

export default AddOnCollection;
